import { defineStore } from "pinia";
import { Ref } from "vue";
import { organizationService } from "./organization.service";
import { useNotification } from "@/utils/notification";
import { INewOrganization } from "./organization.types";
import { ITableHeader } from "@/types/table";

const { pushNotification } = useNotification();

export const useOrganizationStore = defineStore("organization", () => {
  const organizationHeaders: ITableHeader[] = [
    {
      name: "id",
      label: "No",
      width: "3%",
    },
    {
      name: "name",
      label: "Organization",
      width: "18%",
    },
    {
      name: "created_time",
      label: "Created time",
      width: "18%",
    },
    {
      name: "updated_time",
      label: "Updated time",
      width: "18%",
    },
    {
      name: "billing_email",
      label: "Email",
      width: "18%",
    },
    {
      name: "status",
      label: "Status",
      width: "18%",
    },
    {
      name: "actions",
      label: "Actions",
      width: "7%",
    },
  ];

  async function getOrganizationList(loading: Ref<boolean>, cl: any) {
    loading.value = true;

    await organizationService
      .getList()
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function createOrganization(
    loading: Ref<boolean>,
    payload: INewOrganization,
    cl: any
  ) {
    loading.value = true;

    await organizationService
      .createOrganization(payload)
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function updateOrganization(
    loading: Ref<boolean>,
    payload: INewOrganization,
    organization_id: string,
    cl: any
  ) {
    loading.value = true;

    await organizationService
      .updateOrganization(organization_id, payload)
      .then((res) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  return {
    organizationHeaders,
    getOrganizationList,
    createOrganization,
    updateOrganization,
  };
});
